import {
  DashboardOutline,
  FormOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  MailOutline,
  PhoneOutline,
  GlobalOutline,
  BankOutline,
  ExportOutline,
  InfoCircleOutline,
  EyeOutline,
  CaretUpOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  LeftOutline,
  RightOutline,
  TeamOutline,
  UserOutline,
  UserAddOutline,
  LockOutline,
  LogoutOutline,
  SettingOutline,
  WarningOutline,
  QuestionCircleOutline,
  PlusOutline,
  CaretDownOutline,
  DeleteOutline,
  SearchOutline,
  CalendarOutline,
  LoadingOutline,
  SafetyCertificateOutline,
  PullRequestOutline,
  KeyOutline,
  EditOutline,
  StopOutline,
  CheckCircleOutline,
  FileTextOutline,
  ShoppingCartOutline,
  FilterOutline,
  UnorderedListOutline,
  ScheduleOutline,
} from '@ant-design/icons-angular/icons';

export const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  DashboardOutline,
  FormOutline,
  MailOutline,
  PhoneOutline,
  GlobalOutline,
  BankOutline,
  ExportOutline,
  InfoCircleOutline,
  EyeOutline,
  CaretUpOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  LeftOutline,
  RightOutline,
  TeamOutline,
  UserOutline,
  UserAddOutline,
  LockOutline,
  LogoutOutline,
  SettingOutline,
  WarningOutline,
  QuestionCircleOutline,
  PlusOutline,
  CaretDownOutline,
  DeleteOutline,
  SearchOutline,
  CalendarOutline,
  LoadingOutline,
  SafetyCertificateOutline,
  PullRequestOutline,
  KeyOutline,
  EditOutline,
  StopOutline,
  CheckCircleOutline,
  FileTextOutline,
  ShoppingCartOutline,
  FilterOutline,
  UnorderedListOutline,
  ScheduleOutline,
];
